import React from 'react';
import Select from 'react-select';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus, faTimes} from '@fortawesome/free-solid-svg-icons';
import {DESCRIPTION_VARIABLES, descriptionTemplateLabel, descriptionTemplateSlots, descriptionTemplateFromSlots} from '../../utils/workflow-item-description';

/** Use invoice-number chips and separators, including editable custom-text chips. */
export default function ItemDescriptionTemplate({value, onChange, data, selectStyles}) {
    const read = key => data.t.read(key);
    const options = DESCRIPTION_VARIABLES.map(type => ({value: type, label: read(`rule.description_${type}`)}));
    const {variables, texts} = descriptionTemplateSlots(value);
    const save = (nextVariables, nextTexts) => onChange(descriptionTemplateFromSlots(nextVariables, nextTexts));
    const updateText = (index, text) => save(variables, texts.map((old, i) => i === index ? text : old));
    // Remove the adjacent separator, retaining both outer literal slots.
    const remove = index => {
        const nextTexts = [...texts];
        if (variables.length === 1) nextTexts.splice(0, 2, texts[0] + texts[1]);
        else nextTexts.splice(index === variables.length - 1 ? index : index + 1, 1);
        save(variables.filter((_, i) => i !== index), nextTexts);
    };
    return <div className="invoice-number-template col-12">
        <div className="invoice-number-template__builder">
            <div className="invoice-number-template__tokens">
                {variables.map((part, index) => <React.Fragment key={index}>
                    {index > 0 && <input className="invoice-number-template__separator" maxLength={2000}
                        aria-label={`${read('rule.number_separator')} ${index}`} value={texts[index]}
                        onChange={e => updateText(index, e.target.value)} />}
                    <div className={`invoice-number-template__token${part.type === 'custom_text' ? ' invoice-number-template__token--custom-text' : ''}`}>
                        <Select className="invoice-number-template__variable-select" classNamePrefix="select"
                            name={`${read('rule.number_variable_type')} ${index + 1}`}
                            aria-label={`${read('rule.number_variable_type')} ${index + 1}`}
                            options={options} value={options.find(option => option.value === part.type)}
                            styles={selectStyles} menuPortalTarget={document.body} menuPlacement="auto"
                            isClearable={false}
                            onChange={choice => save(variables.map((old, i) => i === index ? {type: choice.value, ...(choice.value === 'custom_text' ? {text: ''} : {})} : old), texts)} />
                        {part.type === 'custom_text' && <input className="invoice-number-template__custom-text" maxLength={2000}
                            aria-label={`${read('rule.description_custom_text')} ${index + 1}`} value={part.text || ''}
                            onChange={e => save(variables.map((old, i) => i === index ? {...part, text: e.target.value} : old), texts)} />}
                        <button type="button" className="invoice-number-template__remove" aria-label={`${read('rule.number_remove')} ${index + 1}`} onClick={() => remove(index)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </React.Fragment>)}
            </div>
            <div className="invoice-number-template__insert">
                <button type="button" className="btn btn-outline-primary btn-sm" disabled={variables.length >= 19}
                    onClick={() => save([...variables, {type: 'existing_description'}], variables.length ? [...texts.slice(0, -1), ', ', texts.at(-1)] : [texts[0], ''])}>
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />{read('rule.number_insert_variable')}
                </button>
            </div>
        </div>
        <div className="small mt-2 text-muted">{read('rule.number_example')}: <output className="text-dark">{descriptionTemplateLabel(value, read, true)}</output></div>
        <div className="small mt-1 text-muted">{read('rule.description_missing_hint')}</div>
    </div>;
}
